import Vue from "vue";
import Util from "./Util";

Vue.filter("capitalize", Util.capitalize);
